import register from './modules/register'
import forms from './modules/forms'
import questions from './modules/questions'

export default {
  register,
  forms,
  questions,
}
